import * as THREE from 'three';
import { OrthoSprite } from './orthosprite';
import { Font } from '../util/font';

class _DamageRender {
  sprites: any[];
  isPlaying: boolean;

  constructor() {
    this.sprites = [];
    this.isPlaying = false;
  }

  add(amount: number, pos: any) {
    const texture = Font.createTEXTure(Font.FONT.OUTLINE_BOLD_24, amount === 0 ? "Miss" : amount.toString());

    // Recreate the sprite with new texture
    const material = new THREE.SpriteMaterial({ map: texture, color: 0xffffff });
    material.depthWrite = false;
    const sprite = new OrthoSprite(material);
    sprite.position.copy(pos);
    sprite.scale.set(texture.image.width, texture.image.height, 1);
    sprite.offset.set(0, 0, 0);

    sprite.baseWidth = texture.image.width;
    sprite.baseHeight = texture.image.height;
    sprite.currentTime = 0.0;

    this.sprites.push(sprite);
    scene.add(sprite);

    if (!this.isPlaying) {
      (THREE as any).AnimationHandler.play(this);
      this.isPlaying = true;
    }
  }

  resetBlendWeights() {
  }

  update(delta: number) {
    for (let i = 0; i < this.sprites.length; ++i) {
      const sprite = this.sprites[i];
      sprite.currentTime += delta;

      sprite.renderSprite.material.opacity = Math.min(1, 1 - (sprite.currentTime - 0.5));
      sprite.position.z += delta * 0.35;

      const scaleVal = Math.min(1, 1 - (sprite.currentTime - 0.5) * 0.7);
      sprite.scale.set(sprite.baseWidth * scaleVal, sprite.baseHeight * scaleVal, 1);

      if (sprite.currentTime > 1.5) {
        scene.remove(sprite);
        this.sprites.splice(i, 1);
        --i;
      }
    }

    if (this.sprites.length === 0) {
      (THREE as any).AnimationHandler.stop(this);
      this.isPlaying = false;
    }
  }
}

export const DamageRender = new _DamageRender();
